import React from "react";
import EiaButton from "../EiaButton";
import EiaDialog from "./EiaDialog";
import EiaSelect from "../EiaSelect";
import {REJECT_REASONS_SELLER_TO_BIDDER, REJECT_REASONS_SELLER_TO_BUYER} from "../../commons/enums/BackendEnums";

function RejectBidDialog(props) {
    const { onClose, open, rejectBid, isBidderBuyer} = props;

    const [reasonIndex, setReasonIndex] = React.useState(0);

    const reasonMap = isBidderBuyer ? REJECT_REASONS_SELLER_TO_BUYER : REJECT_REASONS_SELLER_TO_BIDDER;
    const reasons = Array.from(reasonMap.values());
    const reasonKeys = Array.from(reasonMap.keys());

    const handleClickReject = function() {
        rejectBid(reasonKeys[reasonIndex]);
        onClose();
    }

    return (
        <EiaDialog open={open} onClose={onClose} title={"Please select a reason to reject the bid"} maxWidth={"xl"}>
            <EiaSelect title={"Rejection Reason"} values={reasons} value={reasonIndex} onChange={(e) => setReasonIndex(e.target.value)}/>
            <EiaButton isFullWidth={true} colorTheme={"error"} onClick={handleClickReject}>Reject</EiaButton>
        </EiaDialog>
    );
}

export default RejectBidDialog;